<template>
    <div class="addMemberes cliqueCls">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
          <el-row :gutter="120">
            <el-form-item label="选择门店" prop='addressProvince'>
              <el-input v-model="form.addressProvince" style="width:200px;margin-right:20px;" disabled></el-input>
              <el-input v-model="form.addressCity" style="width:280px" disabled></el-input>
              <el-input v-model="form.storeName" style="width:500px;display: block;margin-top:15px;" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop='applyPhone'>
              <el-input v-model="form.applyPhone" placeholder="请输入联系电话" style="width:500px"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop='applyName'>
              <el-input v-model="form.applyName" placeholder="请输入姓名" style="width:500px"></el-input>
            </el-form-item>
            <el-form-item label="到店时间" prop='dateTime'>
              <el-date-picker v-model="form.dateTime" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" range-separator="-" start-placeholder="选择开始日期" end-placeholder="选择结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="申请类型" prop='applyType'>
              <el-select v-model='form.applyType'>
                <el-option v-for='item in form.applayOption' :value='item.dictKey' :key='item.dictKey' :label='item.dictName'></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row class="btnOptions" style="text-align: left;margin:20px 0 0 50px;">
              <el-button type="warning" plain @click="cliqBack">返回</el-button>
              <el-button class="redBtn" @click="submitAp('form')">提交</el-button>
          </el-row>
        </el-form>
    </div>
</template>
<script>
import infolist from '@/assets/js/info'
import {listAreaInfo, selectDict, submitApplyOrder} from "@/api";
export default {
  data() {
    /*验证手机号*/
    const isvalidateMobile = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^1[3456789]\d{9}$/.test(value) == false) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      form: {
        applyPhone:this.$store.state.userInfo.shopTelephone,
        applyName:this.$store.state.userInfo.bossName,
        addressProvince:'',
        addressCity:'',
        storeName:this.$store.state.userInfo.storeName,
        dateTime:[],
        applayOption:[],
        applyType:''
      },
      rules: {
        applyName: [
          { required: true, message: "请输入申请人姓名", trigger: "blur" },
        ],
        applyPhone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { validator: isvalidateMobile, trigger: "blur" }
        ],
        dateTime: [
          { required: true, message: "请选择到店时间", trigger: "blur" },
        ],
      },
    };
  },
  created() {
   this.listArea()
  },
  methods: {
    listArea(){
      listAreaInfo({}).then(res => {
       for(let i in res.data){
         if(this.$store.state.userInfo.addressProvince == i){
           this.form.addressProvince = res.data[i]
         }
         if(this.$store.state.userInfo.addressCity == i){
           this.form.addressCity = res.data[i]
         }
       }
      });
      selectDict({dictType:16}).then(res =>{
        this.form.applayOption = res.obj;
        this.form.applyType = this.form.applayOption[0].dictKey;
      });
    },
    submitAp(formName){ //tijiao
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let postData = {
            shopId:this.$store.state.userInfo.shopId,
            applyPhone:this.form.applyPhone,
            applyType:this.form.applyType,
            applyName:this.form.applyName,
            assistDateStart:this.form.dateTime[0] ? this.form.dateTime[0] : '',
            assistDateEnd:this.form.dateTime[1] ? this.form.dateTime[1] : '',
            systemType:this.$store.state.userInfo.brandId
          }
          submitApplyOrder(postData).then(res => {
            this.form.dateTime = []
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.cliqBack()
          });
        };
      });
    },
    cliqBack(){
      this.$router.push("/cliqueBusinessCenter/cliqueWork");
    }
  }
};
</script>
<style lang="less" scoped>
.addMemberes {
  width: 100%;
  overflow: hidden;
  padding: 50px 50px 70px;
  .uploadLists {
    display: inline-block;
  }
  .borTop {
    border-top: 1px dashed #c0c5cf;
    padding-top: 25px;
  }
  .staffTips {
    font-size: 13px;
    color: #666;
    margin: 60px 0;
    padding-left: 52px;
  }
  .workList{
    position: relative;
    .deleteWork{
      cursor: pointer;
      width: 22px;
      height: 22px;
      background: url(../../assets/images/store/dele.png) no-repeat center;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 999
    }
  }
  .addWork{
    text-align: center;
    margin-bottom: 20px;
    cursor: pointer;
  }
}
</style>
<style lang="less">
 .cliqueCls .el-input__inner{
   border-radius:0px;
 }
.addMemberes .btnOptions {
  text-align: center;
  .el-button {
    width: 135px;
    height: 46px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/groupWork/addApply.vue